type Props = {
  title: string
  courseCode?: string | null
}

export const getCourseName = ({ courseCode, title }: Props) => {
  return [courseCode, title].filter(Boolean).join(": ")
}
